export const IS_FROM_LOGIN = 'IS_FROM_LOGIN';
export const RESET_IS_FROM_LOGIN = 'RESET_IS_FROM_LOGIN';
